/**
 * Base class for expected, user-facing failures (bad input, validation, etc.)
 * that are a normal outcome of user actions, not bugs. Throw this (or a
 * subclass) instead of a plain `Error` when the failure shouldn't be reported:
 * monitoring skips it by type (see `captureException` and `beforeSend`), and
 * matching on `instanceof UserFacingError` also catches any subclass. This
 * keeps Sentry/Datadog free of noise without matching on a brittle message
 * string.
 *
 * Lives in its own module (rather than src/lib/monitoring) so tests that
 * fully mock the monitoring module don't take the class down with it for
 * every import graph that throws a subclass.
 */
export class UserFacingError extends Error {
  override readonly name: string = "UserFacingError";
}
